"use client";

import { ReactNode, Suspense } from "react";
import { usePathname } from "next/navigation";
import { trpc } from "@zapier/client";
import { CurrentAccountIdProvider } from "@zapier/identity";
import { UniversalLayout } from "@zapier/universal-layout";
import type { EventNameType } from "@zapier/avro-events";
import { NotificationProvider } from "@zapier/utils";
import { DefaultViewProvider } from "@zapier/zaps";
import { TrackRouting, initializeDatadogRum, datadogRumErrors, nextJsReportWebVitals } from "../observability";
import { DevTools } from "./DevTools";
import styles from "./AppLayout.module.css";
import { emitEvent } from "@zapier/shared";
import dynamic from "next/dynamic";
import Wootric from "./Wootric";
const HeldRunsBannerWrapper = dynamic(() => import("@zapier/held-runs-embed").then(module => module.HeldRunsBannerWrapper), {
  ssr: false
});
interface Props {
  children: ReactNode;
}

// Measure and report web vitals that Next.js tracks to Datadog.
// See: https://nextjs.org/docs/advanced-features/measuring-performance
initializeDatadogRum();
export const reportWebVitals = nextJsReportWebVitals;
export const rumErrors = datadogRumErrors;
function AppLayout({
  children
}: Props) {
  const pathname = usePathname();
  return <CurrentAccountIdProvider data-sentry-element="CurrentAccountIdProvider" data-sentry-component="AppLayout" data-sentry-source-file="AppLayout.tsx">
      <NotificationProvider data-sentry-element="NotificationProvider" data-sentry-source-file="AppLayout.tsx">
        <TrackRouting data-sentry-element="TrackRouting" data-sentry-source-file="AppLayout.tsx">
          <UniversalLayout currentUrl={pathname || ""} mainContentId="asset-management-main" showSimplifiedFooter={true} trackEvent={(eventName: string, options = {}) => {
          emitEvent(eventName as EventNameType, {
            ...options
          });
        }} data-sentry-element="UniversalLayout" data-sentry-source-file="AppLayout.tsx">
            <Suspense data-sentry-element="Suspense" data-sentry-source-file="AppLayout.tsx">
              <DefaultViewProvider data-sentry-element="DefaultViewProvider" data-sentry-source-file="AppLayout.tsx">
                <DevTools data-sentry-element="DevTools" data-sentry-source-file="AppLayout.tsx">
                  <HeldRunsBannerWrapper data-sentry-element="HeldRunsBannerWrapper" data-sentry-source-file="AppLayout.tsx" />
                  <div className={styles.content}>{children}</div>
                  <Wootric data-sentry-element="Wootric" data-sentry-source-file="AppLayout.tsx" />
                </DevTools>
              </DefaultViewProvider>
            </Suspense>
          </UniversalLayout>
        </TrackRouting>
      </NotificationProvider>
    </CurrentAccountIdProvider>;
}
export default trpc.withTRPC(AppLayout);